import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Scrollbars } from 'react-custom-scrollbars';
import makeRequest from 'utils/makeRequest';
import { getOuterHeight } from 'utils/DOMUtils';
import { getUserLocation, getCityByLatLong } from 'utils/geoUtils';
// import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { ENT_CITY_LIST_API } from 'constants/index';
import s from './CityModal.scss';

class CityModal extends React.Component {
  constructor() {
    super();
    this.state = {
      items: [],
      searchInput: '',
      filteredCities: [],
      confirmMakingDefCity: false,
      showLocationAccessDenied: false,
    };
    this.ref = React.createRef();
  }

  static ESCAPE_KEY_CODE = 27;

  componentDidMount() {
    this.fetchNavigation(ENT_CITY_LIST_API);
    window.addEventListener('keydown', this.listenKeyEvents);
    if (document?.querySelector) {
      document.querySelector('body').classList.add('overflowhidden');
    }
  }

  componentWillUnmount() {
    if (document?.querySelector) {
      document.querySelector('body').classList.remove('overflowhidden');
    }
    window.removeEventListener('keydown', this.listenKeyEvents);
  }

  listenKeyEvents = event => {
    const { toggleModal } = this.props;
    if (
      event.keyCode === CityModal.ESCAPE_KEY_CODE &&
      typeof toggleModal === 'function'
    ) {
      toggleModal();
    }
  };

  getGaObject(subLabel) {
    const { gaData } = this.props;
    if (gaData && gaData.gaAction && gaData.partialGaLabel) {
      return {
        data: {
          gaAction: gaData.gaAction,
          gaLabel: `${gaData.partialGaLabel}${subLabel}`,
        },
      };
    }
    return {};
  }

  toggleLoader(loading) {
    if (typeof this.props.toggleLoader === 'function') {
      this.props.toggleLoader(loading);
    }
  }
  handleClick = item => {
    const { onChangeCallback = () => {} } = this.props;
    onChangeCallback(item);
    this.closeListingDropdown();
    this.toggleLoader(true);
    // sendGaThroughProps(this.getGaObject(item.clickedItem.name));
  };

  fetchNavigation(dataUrl) {
    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (!(data && data.data)) {
          return;
        }
        const { items } = data.data;
        this.setState({
          items,
        });
      });
  }

  onSearch = e => {
    const { items } = this.state;
    const searchInput = e.target.value || '';
    let cityList;
    this.setState({
      searchInput,
    });

    let filteredCities = items;

    if (searchInput && searchInput.length) {
      filteredCities = {};
      const lowerCaseSearchInput = searchInput.toLowerCase();
      for (let counter = 0; counter < items.length; counter += 1) {
        if (
          items[counter].name &&
          items[counter].name.toLowerCase() === lowerCaseSearchInput[0]
        ) {
          const cities = [];
          cityList = items[counter].items;
          for (let j = 0; j < cityList.length; j += 1) {
            if (
              cityList[j] &&
              cityList[j].name &&
              cityList[j].name
                .toLowerCase()
                .substring(0, searchInput.length) === lowerCaseSearchInput
            ) {
              cities.push(cityList[j]);
            }
          }

          if (cities && cities.length > 0) {
            filteredCities = [{ name: items[counter].name, items: cities }];
          }

          break;
        }
      }
    }
    // const filteredCities = items.filter(node => {
    //   const alphabet =
    //     typeof node.name === 'string' ? node.name.toLowerCase() : '';
    //   return alphabet === searchInput[0]?.toLowerCase() && node;
    // });

    this.setState({
      filteredCities,
    });
  };

  selectCity = (e, cityObj) => {
    e.preventDefault();
    this.props.changeTopBarCity(cityObj, true);
    this.props.toggleModal(e);
  };

  handleConfirmInput = () => {
    const { confirmMakingDefCity } = this.state;
    this.setState({
      confirmMakingDefCity: !confirmMakingDefCity,
    });
  };

  scrollToCities = (event, alphabet) => {
    const upperAlphabet =
      typeof alphabet === 'string' ? alphabet.toUpperCase() : '';
    if (this.ref && this.ref.current) {
      const containerToScroll = this.ref.current.querySelectorAll(
        `[data-letter=${upperAlphabet}]`,
      )[0];
      if (!(containerToScroll && containerToScroll.offsetTop)) {
        return;
      }
      if (typeof containerToScroll.scrollIntoView === 'function') {
        containerToScroll.scrollIntoView({ behavior: 'smooth' });
      } else {
        this.ref.current.scrollTo({
          top: containerToScroll.offsetTop - getOuterHeight(containerToScroll),
          behavior: 'smooth',
        });
      }
    }
  };

  renderAlphabhets(items) {
    return (
      <div className={s.atoz}>
        <ul>
          {items.map(node => (
            <li onClick={e => this.scrollToCities(e, node.name)}>
              <button>{node.name}</button>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  renderCities(items) {
    return (
      <div className={s.alphacont_wrapper} ref={this.ref}>
        {items instanceof Array && items.length ? (
          items.map(node => (
            <div
              className={s.data_alpha}
              data-letter={
                typeof node.name === 'string' ? node.name.toUpperCase() : ''
              }
            >
              {node.items instanceof Array &&
                node.items.map(cityObj => (
                  <a
                    href="/"
                    className={
                      cityObj.name === this.props.entCity ? s.active : ''
                    }
                    onClick={e => this.selectCity(e, cityObj)}
                  >
                    {cityObj.name} <span>({cityObj.state})</span>
                  </a>
                ))}
            </div>
          ))
        ) : (
          <div className={s.noresult}>
            <i />Sorry! No result found.
          </div>
        )}
      </div>
    );
  }

  showLocationAccessDeniedPopup = () => {
    this.setState({ showLocationAccessDenied: true });
  };

  closeLocationAccessDeniedPopup = () => {
    this.setState({ showLocationAccessDenied: false });
  };

  detectUserLocation = () => {
    // logic to detect user location. If detection is success then save the city detail
    getUserLocation(
      this.locationDetectionSucess,
      this.showLocationAccessDeniedPopup,
    );
    // make call to city state mapping API and fetch the data then save this data to cookie
    // this.props.changeTopBarCity(cityObj, true);
  };

  locationDetectionSucess = loc => {
    getCityByLatLong(
      loc.coords.latitude,
      loc.coords.longitude,
      this.props.changeTopBarCity,
    );
  };

  render() {
    const {
      items,
      searchInput,
      filteredCities,
      showLocationAccessDenied,
    } = this.state;
    const { entCity, entState, isWap } = this.props;
    if (!(Array.isArray(items) && items.length > 0)) {
      return null;
    }

    return (
      <div className={`${s.Overlay} ${isWap ? 'mob_class' : ''}`}>
        <div className={s.citybloacker}>
          <div className={s.citybloacker_cont}>
            <div className={s.title_search}>
              <div>
                <div className={s.title}>Select a City</div>
              </div>
              <button
                className={s.closecitypop}
                onClick={e => this.props.toggleModal(e)}
              >
                Close
              </button>
            </div>

            <div className={s.crntcitybox}>
              <label htmlFor="searchcity" className={s.crntcity}>
                Your current city: <span>{entCity}</span>{' '}
                <span>({entState})</span>
              </label>
              <div className={s.searchbox}>
                <form>
                  <input
                    type="text"
                    className={s.searchbox1}
                    placeholder="Search a city..."
                    onChange={event => {
                      this.onSearch(event);
                    }}
                    value={searchInput}
                  />
                  <i className={s.search_icon} />
                </form>
              </div>
            </div>
            {isWap && (
              <div
                className={s.detectlocationbox}
                onClick={() => this.detectUserLocation()}
              >
                Detect my current location <i />
              </div>
            )}
            {typeof searchInput === 'string' &&
            searchInput.trim().length === 0 ? (
              <>
                {!isWap && this.renderAlphabhets(items)}
                <div className={s.alpha_content}>
                  {this.renderCities(items)}
                </div>
              </>
            ) : (
              <div className={s.alpha_content}>
                {this.renderCities(filteredCities)}
              </div>
            )}
          </div>
          {/* below div is coming onlye in mobile */}
          {isWap &&
            showLocationAccessDenied && (
              <div className={s.detectblk}>
                <i /> We dont have permission to access your location. Please
                type your location and search again.
                <button
                  className={s.closedetectblk}
                  onClick={() => {
                    this.closeLocationAccessDeniedPopup();
                  }}
                >
                  +
                </button>
              </div>
            )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

CityModal.propTypes = {
  onChangeCallback: PropTypes.func,
  //showSearchBox: PropTypes.bool,
  toggleModal: PropTypes.func,
  gaData: PropTypes.shape({}),
  toggleLoader: PropTypes.func,
  geoCityData: PropTypes.shape({}),
  changeTopBarCity: PropTypes.func,
  isMobile: PropTypes.bool,
};
CityModal.defaultProps = {
  toggleModal: () => {},
  gaData: undefined,
  onChangeCallback: undefined,
  toggleLoader: undefined,
  geoCityData: {},
  changeTopBarCity: () => {},
  isMobile: false,
};

export default connect(mapStateToProps)(CityModal);
